import React from 'react';
import './ErrorMask.scss';
import { Button } from 'components/form/Button';
import BodyContainer from 'components/Containers/BodyContainer/index';
import { Row } from 'components/Containers/Row/Row';
import { getImageBasePath, isProduction } from 'helpers/env';
import { withRouter } from 'react-router-dom';
import Label from 'components/form/Label/Label';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';
import { OVERVIEW_URL } from 'types/mrph.routes.constants';

const defaultOnClick = () => {
  window.location.pathname = OVERVIEW_URL;
};

const ErrorMask = ({
  generalMessage,
  errorList,
  buttonLabel,
  onClick,
  secondaryMessage,
  isModal,
  imagePath,
  imageWidth,
  bodyCustomClass,
  ...props
}) => {
  const title = generalMessage;
  const shouldShowErrors = !isProduction() && errorList.length > 0;
  const bodyClass = classnames(
    'cs-error',
    { 'isModal padB16': isModal },
    bodyCustomClass,
  );
  const titleLabelType = props.titleType ?? 'H1';
  const finalImagePath = getImageBasePath() + 'images/' + imagePath;

  return (
    <BodyContainer
      showStickyInfoBar={false}
      datatestid="error-mask"
      className={bodyClass}
    >
      <Row fullWidth>
        <FlexContainer className="flex-column items-align-center">
          <img
            className="errormask-image margB20"
            alt={title}
            src={finalImagePath}
            style={{ width: imageWidth }}
          />
          <TitleContainer className="text-center">
            <Label type={titleLabelType}>{title}</Label>
          </TitleContainer>
          {shouldShowErrors && (
            <ul className="margB24">
              {errorList.map(error => (
                <li>{error}</li>
              ))}
            </ul>
          )}
          {secondaryMessage && (
            <Label className="Body-1 margB32">{secondaryMessage} </Label>
          )}
          {!props.hideButton && (
            <Button rounded onClick={onClick} mrphType="primary">
              {buttonLabel}
            </Button>
          )}
        </FlexContainer>
      </Row>
    </BodyContainer>
  );
};

ErrorMask.defaultProps = {
  errorList: [],
  generalMessage: 'This page is temporarily unavailable',
  secondaryMessage: 'Please refresh the page or try again later.',
  onClick: defaultOnClick,
  buttonLabel: 'Go to dashboard',
  imagePath: 'page_error.png',
};

const connectedErrorMask = withRouter(ErrorMask);
export default connectedErrorMask;
